import { useEffect, useState, useContext, useRef } from "react";
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { UserContext } from "../../../context/UserContext";
import axios from "axios";
import { BASELINE } from "../../../util";
import { motion } from "framer-motion";
import ModalComponent from "../pick_modal";
import OverallAI from "../AI_Chat/OverallAI";

ChartJS.register(ArcElement, Tooltip, Legend);

const OverallSAT89Anal = () => {
  const boxItemLeftRef = useRef();

  const { user } = useContext(UserContext);
  const [selected, setSelected] = useState('English');  // Default selection
  const [eproblems, seteproblems] = useState([]);
  const [mproblems, setmproblems] = useState([]);
  const [co, setco] = useState(0);
  const [inco, setinco] = useState(0);
  const [omit, setomit] = useState(0);

  const [report_eng, set_report_eng] = useState([]);
  const [report_math, set_report_math] = useState([]);
  const [selectedTopic, setSelectedTopic] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [analcomp, setanalcomp] = useState(0);

  const [tag, settag] = useState('');
  const [hideExplanation, setHideExplanation] = useState(false);
  const [topic, settopic] = useState(false);
  const [section, setsection] = useState("");

  const handleChange2 = () => {
    setHideExplanation(!hideExplanation);
  };

  useEffect(() => {
    getting_problems();
    getallsat();
    getusersat();
  }, []);

  useEffect(() => {
    // Dynamically load the KaTeX script
    const script2 = document.createElement('script');
    script2.src = 'https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/contrib/auto-render.min.js';
    script2.integrity = 'sha384-+VBxd3r6XgURycqtZ117nYw44OOcIax56Z4dCRWbxyPt0Koah1uHoK0o4+/RRE05';
    script2.crossOrigin = 'anonymous';

    // Handle script load
    script2.onload = () => {
      if (boxItemLeftRef.current) {
        const options = {
          delimiters: [
            { left: '$$', right: '$$', display: false },
            { left: "$", right: "$", display: false },
            { left: '\\(', right: '\\)', display: false },
            { left: '\\[', right: '\\]', display: true },
            { left: '\\begin{array}', right: '\\end{array}', display: true }
          ],
          throwOnError: false,
        };

        window.renderMathInElement(boxItemLeftRef.current, options);
      }
    };
    document.body.appendChild(script2);

    // Cleanup: remove the script when component unmounts
    return () => {
      document.body.removeChild(script2);
    };
  }, [selectedTopic, hideExplanation]);

  const getsatquestion = (questionId, tag) => {
    settag(tag);
    axios.get(BASELINE + "questions/psat89/byqid", {
      params: {
        qid: questionId
      }
    })
      .then(response => {
        setSelectedTopic(response.data);
        setIsModalOpen(true);
      })
      .catch(err => {
        console.error("Error fetching SAT question data:", err);
      });
  }

  const updateScoresWithApiData = (apiData) => {
    setScores(prevScores => {
      // Create a map from the API data for quick lookup
      const data = Array.isArray(apiData) ? apiData : [];
      const apiScoresMap = data.reduce((acc, item) => {
        acc[item.test_name] = item.total_score;
        return acc;
      }, {});

      // Map over the existing scores and update 'myScore' if there's a matching entry in the API data
      return prevScores.map(score => ({
        ...score,
        myScore: apiScoresMap[score.name] || score.myScore
      }));
    });
  }

  const getusersat = () => {
    axios.get(`${BASELINE}get/user/sat89`, {
      params: {
        user_id: user.u_id
      }
    })
      .then(response => {
        // 빈 데이터가 들어올 수 있으므로 안전 처리
        const data = response.data || [];
        updateScoresWithApiData(data);
      })
      .catch(err => {
        console.error("Error fetching user SAT data:", err);
      });
  }

  const getallsat = () => {
    axios.get(`${BASELINE}get/all/sat`)
      .then(response => {
        // 빈 배열일 때 에러가 발생하지 않도록 안전 처리
        const data = response.data || [];
        // Aggregate scores by test_name
        const scoresMap = data.reduce((acc, item) => {
          if (!acc[item.test_name]) {
            acc[item.test_name] = { total: 0, count: 0 };
          }
          acc[item.test_name].total += item.total_score;
          acc[item.test_name].count += 1;
          return acc;
        }, {});

        // Calculate averages and round them
        const averages = Object.keys(scoresMap).map(test => ({
          test_name: test,
          avgScore: Math.round(scoresMap[test].total / scoresMap[test].count)
        }));

        // Update the scores array
        const updatedScores = scores.map(score => {
          const averageData = averages.find(avg => avg.test_name === score.name);
          return {
            ...score,
            avgScore: averageData ? averageData.avgScore : score.avgScore
          };
        });

        setScores(updatedScores);
      })
      .catch(err => console.error("Error fetching SAT scores:", err));
  }

  const getting_problems = () => {
    axios.get(`${BASELINE}tests/byuser/psat89/${user.u_id}`)
      .then(response => {
        // response.data가 비어있을 수 있으므로 기본값 처리
        const userData = response.data || [];

        const allIncorrectIds = userData.reduce((acc, test) => {
          if (test.Incorrect_questionIds) {
            const incorrectIds = JSON.parse(test.Incorrect_questionIds);
            acc = acc.concat(incorrectIds);
          }
          return acc;
        }, []);

        const allcorrectIds = userData.reduce((acc, test) => {
          if (test.Correct_questionIds) {
            const correctIds = JSON.parse(test.Correct_questionIds);
            acc = acc.concat(correctIds);
          }
          return acc;
        }, []);

        const allomittedIds = userData.reduce((acc, test) => {
          if (test.Omitted_questionIds) {
            const omittedIds = JSON.parse(test.Omitted_questionIds);
            acc = acc.concat(omittedIds);
          }
          return acc;
        }, []);

        // 결합
        const allQuestions = [...allIncorrectIds, ...allcorrectIds];

        // 영어/수학 필터
        const engQuestions = allQuestions.filter(question => question.tag === 'eng');
        const mathQuestions = allQuestions.filter(question => question.tag === 'math');

        // Topic별 group
        const groupedByEngTopic = groupByTopic(engQuestions);
        const groupedByMathTopic = groupByTopic(mathQuestions);

        // 자주 틀린 문제
        const topEngQuestions = getTopQuestions(engQuestions);
        const topMathQuestions = getTopQuestions(mathQuestions);

        seteproblems(topEngQuestions);
        setmproblems(topMathQuestions);

        const inco = allIncorrectIds.length;
        const co = allcorrectIds.length;
        const omit = allomittedIds.length;
        const totalQuestions = inco + co + omit;

        // 0으로 나누지 않도록 주의
        if (totalQuestions > 0) {
          const incorrectPercentage = (inco / totalQuestions) * 100;
          const correctPercentage = (co / totalQuestions) * 100;
          const omittedPercentage = (omit / totalQuestions) * 100;

          setco(correctPercentage.toFixed(1));
          setinco(incorrectPercentage.toFixed(1));
          setomit(omittedPercentage.toFixed(1));
          updateChartData(incorrectPercentage, correctPercentage, omittedPercentage);
        } else {
          // 풀이 기록이 하나도 없는 경우
          setco(0);
          setinco(0);
          setomit(0);
          updateChartData(0, 0, 0);
        }

        const engSubjects = transformData(groupedByEngTopic);
        const mathSubjects = transformData(groupedByMathTopic);

        set_report_eng(engSubjects);
        set_report_math(mathSubjects);
        setanalcomp(1);

      })
      .catch(error => {
        console.error("Error fetching user tests:", error);
      });
  }

  const updateChartData = (incorrectPercentage, correctPercentage, omittedPercentage) => {
    setDoughnutData({
      datasets: [{
        data: [incorrectPercentage, correctPercentage, omittedPercentage],
        backgroundColor: ['#FF6384', '#4BC0C0', '#E7E9ED'],
        hoverBackgroundColor: ['#FF6384', '#4BC0C0', '#E7E9ED'],
        borderWidth: 0,
      }],
      labels: ['Incorrect', 'Correct', 'Omitted'],
    });
  };

  const [doughnutData, setDoughnutData] = useState({
    datasets: [{
      data: [7, 93], // Default values
      backgroundColor: ['#FF6384', '#4BC0C0'],
      hoverBackgroundColor: ['#FF6384', '#4BC0C0'],
      borderWidth: 0,
    }],
    labels: ['Incorrect', 'Correct', 'Omitted'],
  });

  const groupByTopic = (questions) => {
    return questions.reduce((acc, question) => {
      const topic = question.topic;
      if (!acc[topic]) {
        acc[topic] = { correct: 0, incorrect: 0, omitted: 0, total: 0 };
      }
      if (question.selectedOption === null) {
        acc[topic].omitted++;
      } else if (question.correct) {
        acc[topic].correct++;
      } else {
        acc[topic].incorrect++;
      }
      acc[topic].total++;
      return acc;
    }, {});
  };

  const calculatePercentage = (count, total) => {
    return `${((count / total) * 100).toFixed(1)}%`;
  };

  const transformData = (groupedData) => {
    return Object.entries(groupedData).map(([topic, counts]) => ({
      name: topic,
      correct: calculatePercentage(counts.correct, counts.total),
      incorrect: calculatePercentage(counts.incorrect, counts.total),
      omitted: calculatePercentage(counts.omitted, counts.total),
    }));
  };

  const getTopQuestions = (questions) => {
    const frequencyMap = questions.reduce((acc, question) => {
      if (!acc[question.questionIds]) {
        acc[question.questionIds] = { count: 0, topic: question.topic };
      }
      acc[question.questionIds].count += 1;
      return acc;
    }, {});

    return Object.entries(frequencyMap)
      .sort((a, b) => b[1].count - a[1].count)
      .slice(0, 10)
      .map(([id, { topic }]) => ({
        id: id,
        name: topic
      }));
  }

  const handleChange = (event) => {
    setSelected(event.target.value);
  };

  const handleRowClick = (subjectName, section) => {
    setsection(section);
    settopic(subjectName);
    setIsModalOpen2(true);
  };

  const [scores, setScores] = useState([
    { name: "psat89_1", myScore: 0, avgScore: 400 },
    { name: "psat89_2", myScore: 0, avgScore: 410 },
    { name: "psat89_3", myScore: 0, avgScore: 420 },
    { name: "psat89_4", myScore: 0, avgScore: 400 },
    { name: "psat89_5", myScore: 0, avgScore: 410 },
    { name: "psat89_6", myScore: 0, avgScore: 420 },
  ]);

  const doughnutOptions = {
    cutout: '60%',
    elements: {
      arc: {
        borderWidth: 0,
        borderRadius: 10,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
      },
    },
  };

  return (
    <>
      <ModalComponent topic={topic} isOpen={isModalOpen2} onClose={setIsModalOpen2} section={section} type={'SAT89'} />
      <div className=" pl-6 pt-6 text-gray-500 text-sm">
        <span className="hover:underline cursor-pointer">My Home</span> &gt; <span className="font-semibold text-black">PSAT 8 & 9 Performance</span>
      </div>

      <div className="ml-[20px] mt-[20px] text-gray-800 text-lg font-semibold">Dashboard</div>
      <hr />
      <div className="flex justify-center items-center space-x-4 p-4">
        <div className="relative flex-3 p-4 rounded" style={{ flex: '0 0 36%' }}>
          <div className="absolute inset-0 border-1 rounded-xl border-transparent bg-gradient-to-r from-purple-400 to-blue-400 p-[2px]">
            <div className="h-full w-full bg-white rounded-xl"></div>
          </div>
          <div className="relative">
            <h2 className="text-lg font-semibold mb-2">👑 Top 10 English Missing Problems</h2>
            <div style={{ height: '180px', overflowY: 'auto' }}>
              <table className="min-w-full" style={{ borderCollapse: 'collapse', border: 'none' }}>
                <thead className="border-b">
                  <tr style={{ border: 'none' }}>
                    <th className="px-4 py-2 text-left" style={{ border: 'none' }}>Topic</th>
                    <th className="px-4 py-2 text-left" style={{ border: 'none' }}>Action</th>
                  </tr>
                </thead>
                <tbody style={{ border: 'none' }}>
                  {eproblems.map((problem) => (
                    <tr key={problem.id} style={{ border: 'none' }}>
                      <td className="px-4 py-2" style={{ border: 'none' }}>{problem.name}</td>
                      <td className="px-4 py-2" style={{ border: 'none' }}>
                        <button
                          className="bg-slate-600 hover:bg-blue-700 text-white font-bold py-1 px-2 rounded"
                          onClick={() => getsatquestion(problem.id, 'Eng')}
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          </div>
        </div>

        <div className="relative flex-3 p-4 rounded" style={{ flex: '0 0 36%' }}>
          <div className="absolute inset-0 border-1 rounded-xl border-transparent bg-gradient-to-r from-purple-400 to-blue-400 p-[2px]">
            <div className="h-full w-full bg-white rounded-xl"></div>
          </div>
          <div className="relative">
            <h2 className="text-lg font-semibold mb-2">👑 Top 10 Math Missing Problems</h2>
            <div style={{ height: '180px', overflowY: 'auto' }}>
              <table className="min-w-full" style={{ borderCollapse: 'collapse', border: 'none' }}>
                <thead className="border-b">
                  <tr style={{ border: 'none' }}>
                    <th className="px-4 py-2 text-left" style={{ border: 'none' }}>Topic</th>
                    <th className="px-4 py-2 text-left" style={{ border: 'none' }}>Action</th>
                  </tr>
                </thead>
                <tbody style={{ border: 'none' }}>
                  {mproblems.map((problem) => (
                    <tr key={problem.id} style={{ border: 'none' }}>
                      <td className="px-4 py-2" style={{ border: 'none' }}>{problem.name}</td>
                      <td className="px-4 py-2" style={{ border: 'none' }}>
                        <button
                          className="bg-slate-600 hover:bg-blue-700 text-white font-bold py-1 px-2 rounded"
                          onClick={() => getsatquestion(problem.id, 'Math')}
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          </div>
        </div>

        <div className="relative flex-3 p-4 rounded" style={{ flex: '0 0 23%' }}>
          <div className="absolute inset-0 border-1 rounded-xl border-transparent bg-gradient-to-r from-purple-400 to-blue-400 p-[2px]">
            <div className="h-full w-full bg-white rounded-xl"></div>
          </div>
          <div className="relative">
            <h2 className="text-lg font-semibold mb-2">🥇 Overall Average SAT Score</h2>
            <div style={{ height: '180px', overflowY: 'auto' }}>
              <table className="min-w-full text-sm" style={{ borderCollapse: 'collapse', border: 'none' }}>
                <thead className="border-b">
                  <tr>
                    <th className="px-4 py-2 text-left" style={{ border: 'none' }}>Test #</th>
                    <th className="px-4 py-2 text-left" style={{ border: 'none' }}>Score</th>
                    <th className="px-4 py-2 text-left" style={{ border: 'none' }}>Avg Score</th>
                  </tr>
                </thead>
                <tbody>
                  {scores.map((score, index) => (
                    <tr key={index} style={{ border: 'none' }}>
                      <td className="px-4 py-2" style={{ border: 'none' }}>{score.name}</td>
                      <td className="px-4 py-2" style={{ border: 'none' }}>{score.myScore}</td>
                      <td className="px-4 py-2" style={{ border: 'none' }}>{score.avgScore}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>

      <div className="ml-[20px] text-gray-800 text-lg font-semibold">Statistics</div>
      <hr />
      <div className="ml-[15px] mr-[15px] mt-[10px] border p-2 bg-white p-4 rounded-lg flex justify-center items-center mb-[10px]">
        <div className="flex w-full">
          <div className="flex">
            <div className="relative w-48 h-48 ml-[80px] mr-[150px] mt-[7px]">
              <Doughnut data={doughnutData} options={doughnutOptions} />
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <p className="text-sm font-semibold"></p>
              </div>
            </div>
          </div>

          <div className="w-4/6 flex flex-col justify-center">
            <div className="text-lg font-semibold mb-4">Total Solved Score</div>
            <div className="space-y-2">
              <div className="flex justify-between">
                <div>Total Correct:</div>
                <div className='bg-gray-200 p-2 rounded-2xl'>{co} %</div>
              </div>
              <hr />
              <div className="flex justify-between">
                <div>Total Incorrect:</div>
                <div className='bg-gray-200 p-2 rounded-2xl'>{inco} %</div>
              </div>
              <hr />
              <div className="flex justify-between">
                <div>Total Omitted:</div>
                <div className='bg-gray-200 p-2 rounded-2xl'>{omit} %</div>
              </div>
              <hr />
            </div>
          </div>
        </div>
      </div>

      <div className="ml-[20px] mt-[20px] text-gray-800 text-lg font-semibold">Reports</div>
      <hr />
      <div className="bg-white m-6 rounded-md border">
        <div className="ml-[20px] mt-[10px] flex items-center space-x-2">
          <label htmlFor="category-select" className="text-sm font-medium">Shows:</label>
          <select
            id="category-select"
            value={selected}
            onChange={handleChange}
            className="bg-transparent border-none border-b border-gray-200 text-gray-700 py-1 focus:ring-0 focus:border-blue-500"
          >
            <option value="English">English</option>
            <option value="Math">Math</option>
          </select>
        </div>

        <div className="w-full">
          <table className="w-full border-none mb-[120px]">
            <thead className="border-b">
              <tr>
                <th className="border-none px-6 py-3 text-left text-gray-500">NAME</th>
                <th className="border-none px-6 py-3 text-left text-gray-500">CORRECT Q</th>
                <th className="border-none px-6 py-3 text-left text-gray-500">INCORRECT Q</th>
                <th className="border-none px-6 py-3 text-left text-gray-500">OMITTED Q</th>
              </tr>
            </thead>
            <tbody>
              {selected === 'English' ? report_eng.map((item) => (
                <tr
                  key={item.name}
                  className="border-none cursor-pointer hover:bg-gray-200"
                  onClick={() => handleRowClick(item.name, "English")}
                >
                  <td className="border-none px-6 py-4">
                    {item.name}
                    <div className="relative w-full mt-2 h-3 rounded-full bg-gray-200 overflow-hidden shadow-inner">
                      <div
                        className="absolute h-full transition-all duration-700 ease-out"
                        style={{
                          width: item.correct,
                          left: 0,
                          background: 'linear-gradient(to right, #00b046, #00b046)'
                        }}
                      >
                        <div className="group relative w-full h-full">
                          <span className="opacity-0 group-hover:opacity-100 transition-opacity absolute top-[-40px] left-1/2 transform -translate-x-1/2 bg-black text-white text-xs rounded py-1 px-2">
                            Correct: {item.correct}
                            <svg className="absolute text-black h-2 w-2 left-1/2 transform -translate-x-1/2 bottom-[-5px]" fill="currentColor" viewBox="0 0 512 512">
                              <path d="M256 294.1l109.3 109.3c3.1 3.1 4.7 7.2 4.7 11.3s-1.6 8.3-4.7 11.3c-6.3 6.3-16.4 6.3-22.6 0L256 317.9l-86.7 86.7c-6.3 6.3-16.4 6.3-22.6 0 -3.1-3.1-4.7-7.2-4.7-11.3s1.6-8.3 4.7-11.3L256 294.1z" />
                            </svg>
                          </span>
                        </div>
                      </div>

                      <div
                        className="absolute h-full transition-all duration-700 ease-out"
                        style={{
                          width: item.incorrect,
                          left: item.correct,
                          background: 'linear-gradient(to right, #00b046, #DC281E)'
                        }}
                      >
                        <div className="group relative w-full h-full">
                          <span className="opacity-0 group-hover:opacity-100 transition-opacity absolute top-[-40px] left-1/2 transform -translate-x-1/2 bg-black text-white text-xs rounded py-1 px-2">
                            Incorrect: {item.incorrect}
                            <svg className="absolute text-black h-2 w-2 left-1/2 transform -translate-x-1/2 bottom-[-5px]" fill="currentColor" viewBox="0 0 512 512">
                              <path d="M256 294.1l109.3 109.3c3.1 3.1 4.7 7.2 4.7 11.3s-1.6 8.3-4.7 11.3c-6.3 6.3-16.4 6.3-22.6 0L256 317.9l-86.7 86.7c-6.3 6.3-16.4 6.3-22.6 0 -3.1-3.1-4.7-7.2-4.7-11.3s1.6-8.3 4.7-11.3L256 294.1z" />
                            </svg>
                          </span>
                        </div>
                      </div>

                      <div
                        className="absolute h-full transition-all duration-700 ease-out"
                        style={{
                          width: item.omitted,
                          left: `calc(${item.correct} + ${item.incorrect})`,
                          background: 'linear-gradient(to right, #DC281E, #757F9A)'
                        }}
                      >
                        <div className="group relative w-full h-full">
                          <span className="opacity-0 group-hover:opacity-100 transition-opacity absolute top-[-40px] left-1/2 transform -translate-x-1/2 bg-black text-white text-xs rounded py-1 px-2">
                            Omitted: {item.omitted}
                            <svg className="absolute text-black h-2 w-2 left-1/2 transform -translate-x-1/2 bottom-[-5px]" fill="currentColor" viewBox="0 0 512 512">
                              <path d="M256 294.1l109.3 109.3c3.1 3.1 4.7 7.2 4.7 11.3s-1.6 8.3-4.7 11.3c-6.3 6.3-16.4 6.3-22.6 0L256 317.9l-86.7 86.7c-6.3 6.3-16.4 6.3-22.6 0 -3.1-3.1-4.7-7.2-4.7-11.3s1.6-8.3 4.7-11.3L256 294.1z" />
                            </svg>
                          </span>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="border-none px-6 py-4">{item.correct}</td>
                  <td className="border-none px-6 py-4">{item.incorrect}</td>
                  <td className="border-none px-6 py-4">{item.omitted}</td>
                </tr>
              )) : report_math.map((item) => (
                <tr
                  key={item.name}
                  className="border-none cursor-pointer hover:bg-gray-200"
                  onClick={() => handleRowClick(item.name, "Math")}
                >
                  <td className="border-none px-6 py-4">
                    {item.name}
                    <div className="relative w-full mt-2 h-3 rounded-full bg-gray-200 overflow-hidden shadow-inner">
                      <div
                        className="absolute h-full transition-all duration-700 ease-out"
                        style={{
                          width: item.correct,
                          left: 0,
                          background: 'linear-gradient(to right, #00b046, #00b046)'
                        }}
                      >
                        <div className="group relative w-full h-full">
                          <span className="opacity-0 group-hover:opacity-100 transition-opacity absolute top-[-40px] left-1/2 transform -translate-x-1/2 bg-black text-white text-xs rounded py-1 px-2">
                            Correct: {item.correct}
                            <svg className="absolute text-black h-2 w-2 left-1/2 transform -translate-x-1/2 bottom-[-5px]" fill="currentColor" viewBox="0 0 512 512">
                              <path d="M256 294.1l109.3 109.3c3.1 3.1 4.7 7.2 4.7 11.3s-1.6 8.3-4.7 11.3c-6.3 6.3-16.4 6.3-22.6 0L256 317.9l-86.7 86.7c-6.3 6.3-16.4 6.3-22.6 0 -3.1-3.1-4.7-7.2-4.7-11.3s1.6-8.3 4.7-11.3L256 294.1z" />
                            </svg>
                          </span>
                        </div>
                      </div>

                      <div
                        className="absolute h-full transition-all duration-700 ease-out"
                        style={{
                          width: item.incorrect,
                          left: item.correct,
                          background: 'linear-gradient(to right, #00b046, #DC281E)'
                        }}
                      >
                        <div className="group relative w-full h-full">
                          <span className="opacity-0 group-hover:opacity-100 transition-opacity absolute top-[-40px] left-1/2 transform -translate-x-1/2 bg-black text-white text-xs rounded py-1 px-2">
                            Incorrect: {item.incorrect}
                            <svg className="absolute text-black h-2 w-2 left-1/2 transform -translate-x-1/2 bottom-[-5px]" fill="currentColor" viewBox="0 0 512 512">
                              <path d="M256 294.1l109.3 109.3c3.1 3.1 4.7 7.2 4.7 11.3s-1.6 8.3-4.7 11.3c-6.3 6.3-16.4 6.3-22.6 0L256 317.9l-86.7 86.7c-6.3 6.3-16.4 6.3-22.6 0 -3.1-3.1-4.7-7.2-4.7-11.3s1.6-8.3 4.7-11.3L256 294.1z" />
                            </svg>
                          </span>
                        </div>
                      </div>

                      <div
                        className="absolute h-full transition-all duration-700 ease-out"
                        style={{
                          width: item.omitted,
                          left: `calc(${item.correct} + ${item.incorrect})`,
                          background: 'linear-gradient(to right, #DC281E, #757F9A)'
                        }}
                      >
                        <div className="group relative w-full h-full">
                          <span className="opacity-0 group-hover:opacity-100 transition-opacity absolute top-[-40px] left-1/2 transform -translate-x-1/2 bg-black text-white text-xs rounded py-1 px-2">
                            Omitted: {item.omitted}
                            <svg className="absolute text-black h-2 w-2 left-1/2 transform -translate-x-1/2 bottom-[-5px]" fill="currentColor" viewBox="0 0 512 512">
                              <path d="M256 294.1l109.3 109.3c3.1 3.1 4.7 7.2 4.7 11.3s-1.6 8.3-4.7 11.3c-6.3 6.3-16.4 6.3-22.6 0L256 317.9l-86.7 86.7c-6.3 6.3-16.4 6.3-22.6 0 -3.1-3.1-4.7-7.2-4.7-11.3s1.6-8.3 4.7-11.3L256 294.1z" />
                            </svg>
                          </span>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="border-none px-6 py-4">{item.correct}</td>
                  <td className="border-none px-6 py-4">{item.incorrect}</td>
                  <td className="border-none px-6 py-4">{item.omitted}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className={`fixed inset-0 flex items-center justify-center z-50 ${isModalOpen ? '' : 'hidden'}`}>
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-85"></div>
        </div>
        {tag === 'Eng' && (
          <div className="relative bg-white w-[100%] h-[95%] overflow-auto">
            <button className="absolute top-0 right-0 p-2" onClick={() => setIsModalOpen(false)}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-6 w-6 text-white">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <div className="bg-slate-700 text-white text-[32px] font-bold pt-[5px] pl-[20px] pt-[20px]">
              Reading and Writing
            </div>
            <div className="flex flex-col md:flex-row">
              <div className="md:w-1/2 w-full mt-[20px] border-b-[1px] md:border-b-0 md:border-r-[1px] border-gray-300">
                <div>
                  <div
                    dangerouslySetInnerHTML={{ __html: selectedTopic.stimulus }}
                    className="max-h-[500px] overflow-y-auto overflow-x-hidden ml-[20px] mt-[10px]"
                  />
                </div>

                <label className="ml-[20px] mt-[20px] md:mt-[100px] flex items-center space-x-2">
                  <input
                    type="checkbox"
                    checked={hideExplanation}
                    onChange={handleChange2}
                    className="form-checkbox h-5 w-5 text-gray-600"
                  />
                  <span>Hide correct answer and explanation</span>
                </label>
              </div>
              <div className="md:w-1/2 w-full md:ml-[20px] md:mr-[20px]">
                <div className="mt-8 flex flex-row justify-between bg-gray-100">
                  <div className="flex flex-row gap-2">
                    <div className="ml-[10px] p-2 flex flex-row items-center gap-1">
                      <div>
                        <p>Question Review</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="my-2 max-w-[600px] max-h-[480px] overflow-y-auto">
                  <div
                    dangerouslySetInnerHTML={{ __html: selectedTopic.stem }}
                    className="ml-[20px]"
                  />
                  <>
                    <Option idx={0} data={selectedTopic.a} />
                    <Option idx={1} data={selectedTopic.b} />
                    <Option idx={2} data={selectedTopic.c} />
                    <Option idx={3} data={selectedTopic.d} />
                  </>
                </div>

                {!hideExplanation && (
                  <div className="mt-[20px]">
                    <div
                      dangerouslySetInnerHTML={{ __html: selectedTopic.rationale2 ? selectedTopic.rationale2 : selectedTopic.rationale }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {tag === 'Math' && (
          <div className="relative bg-white w-[100%] h-[95%] overflow-auto">
            <button className="absolute top-0 right-0 p-2" onClick={() => setIsModalOpen(false)}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-6 w-6 text-white">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <div className="bg-slate-700 text-white text-[32px] font-bold pt-[5px] pl-[20px] pt-[20px]">
              Math
            </div>
            <div className="flex" ref={boxItemLeftRef}>
              <div className="w-1/2 mt-[20px] border-r-[1px] border-gray-300">
                <div>
                  <div
                    dangerouslySetInnerHTML={{ __html: selectedTopic.stem }}
                    className="ml-[20px] max-h-[500px] overflow-y-auto overflow-x-hidden ml-[20px] mt-[10px]"
                  />
                </div>

                <label className="ml-[20px] mt-[100px] flex items-center space-x-2">
                  <input
                    type="checkbox"
                    checked={hideExplanation}
                    onChange={handleChange2}
                    className="form-checkbox h-5 w-5 text-gray-600"
                  />
                  <span>Hide correct answer and explanation</span>
                </label>
              </div>
              <div className="w-1/2 ml-[20px] mr-[20px]">
                <div className="mt-8 flex flex-row justify-between bg-gray-100">
                  <div className="flex flex-row gap-2">
                    <div className="ml-[20px] p-2 flex flex-row items-center gap-1">
                      <div>
                        <p>Question Review</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="my-2 max-w-[600px] max-h-[480px] overflow-y-auto">
                  {selectedTopic.a != null ? (
                    <>
                      <Option idx={0} data={selectedTopic.a} />
                      <Option idx={1} data={selectedTopic.b} />
                      <Option idx={2} data={selectedTopic.c} />
                      <Option idx={3} data={selectedTopic.d} />
                    </>
                  ) : (
                    <input className="w-[90%] border-[1px] py-1 px-2 border-gray-300 outline-none rounded-md" type="text" />
                  )}
                </div>

                {!hideExplanation && (
                  <div className="mt-[20px]">
                    <div
                      dangerouslySetInnerHTML={{ __html: selectedTopic.rationale2 ? selectedTopic.rationale2 : selectedTopic.rationale }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      <OverallAI
        type={'SAT89'}
        handleRowClick={handleRowClick}
        analcomp={analcomp}
        report_eng={report_eng}
        report_math={report_math}
      />
    </>
  );
};

export default OverallSAT89Anal;

const Option = ({ idx, data }) => {
  return (
    <div className="flex flex-row gap-1">
      <motion.div
        whileTap={{ scale: 0.98 }}
        className={`flex flex-row w-full border-[1px] rounded-md border-black gap-2 p-1 m-3 cursor-pointer relative`}
      >
        <div className="flex flex-row items-center">
          <p className="flex flex-row items-center justify-center p-1 w-6 h-6 border-[1px] border-black rounded-full">
            {getOptionLetter(idx)}
          </p>
        </div>
        <div dangerouslySetInnerHTML={{ __html: data }} />
      </motion.div>
    </div>
  );
};

function getOptionLetter(idx) {
  switch (idx) {
    case 0:
      return 'A';
    case 1:
      return 'B';
    case 2:
      return 'C';
    case 3:
      return 'D';
    default:
      return "A";
  }
}
